import { render, staticRenderFns } from "./DpApplicationProfitCenterField.vue?vue&type=template&id=1140ae3f&scoped=true&"
import script from "./DpApplicationProfitCenterField.vue?vue&type=script&lang=js&"
export * from "./DpApplicationProfitCenterField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1140ae3f",
  null
  
)

export default component.exports